import { useNavigate } from 'react-router';

import { ProjectAbstract } from '@/domain/project/entities/project.entity';
import {
  selectIsFetchingProjectsVenue,
  selectProjectVenuesItems,
} from '@/domain/project-venue/project-venue.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { ProjectsPageList } from '@/ui/pages/app/components/projects-page/ProjectsPageList';
import { ProjectsPageTitleAndCreateButton } from '@/ui/pages/app/components/projects-page/ProjectsPageTitleAndCreateButton';

import { ButtonModalCreateProjectVenue } from './components/ButtonModalCreateProjectVenue';

export function ProjectsVenue() {
  const projectItems: ProjectAbstract[] = useAppSelector(
    selectProjectVenuesItems,
  );
  const isFetchingProjects = useAppSelector(selectIsFetchingProjectsVenue);
  const isProjectItemsEmpty = projectItems.length === 0;

  const navigate = useNavigate();

  const onClickProject = (projectId: number) => {
    navigate(`/app/projects/venue/${projectId}`);
  };

  return (
    <>
      <ProjectsPageTitleAndCreateButton
        title={translate('ProjectsVenue.my-seasons')}
        createButton={<ButtonModalCreateProjectVenue />}
        showCreateButton={isProjectItemsEmpty === false}
      />
      <ProjectsPageList
        projectItems={projectItems}
        isFetchingProjects={isFetchingProjects}
        onClickProject={onClickProject}
        noProjectMessage={translate('ProjectsVenue.no-project-message')}
        createButton={<ButtonModalCreateProjectVenue />}
      />
    </>
  );
}
